// extracted by mini-css-extract-plugin
module.exports = {"root":"bd_bj"};